import axios from './axios';

export const getClientContacts = ({ params } = {}) => axios.get(`client_contacts`, { params });
export const getClientContact = ({id, params }) => axios.get(`client_contacts/${id}`, { params });
export const createClientContact = ({ data }) => axios.post('client_contacts', data);
export const updateClientContact = ({ id, data }) => axios.put(`client_contacts/${id}`, data);
export const deleteClientContact = ({ id }) => axios.delete(`client_contacts/${id}`);